import { render } from "./ProposalAcceptedDetails.vue?vue&type=template&id=aa14de78&scoped=true"
import script from "./ProposalAcceptedDetails.vue?vue&type=script&lang=js"
export * from "./ProposalAcceptedDetails.vue?vue&type=script&lang=js"

import "./ProposalAcceptedDetails.vue?vue&type=style&index=0&id=aa14de78&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa14de78"]])

export default __exports__